import { Text } from '../../../../styles/typography'
import courseDetails from '../config/details'
import { DetailsEl } from '../elements'
import CourseHomeStore from '../stores/course-home-store'

const Details = () => {
  const { data } = CourseHomeStore.useContainer()

  return (
    <DetailsEl>
      {courseDetails[data?.type].map(({ id, text, icon, condition }) =>
        condition(data) ? (
          <div className='detail' key={id}>
            {icon}
            <Text>{text(data)}</Text>
          </div>
        ) : null,
      )}
    </DetailsEl>
  )
}

export default Details
